import { validationMessages } from '../../utils/validationMessages';

const MembershipFormModel = {
  formField: {
    Title: {
      name: 'Title',
      label: 'Title'
    },
    FirstName: {
      name: 'FirstName',
      label: 'First name*',
      maxStringCount: 71,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    MiddleName: {
      name: 'MiddleName',
      label: 'Middle name',
      maxStringCount: 90,
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    Surname: {
      name: 'Surname',
      label: 'Surname*',
      maxStringCount: 171,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    Preferredname: {
      name: 'PreferredName',
      label: 'Preferred name',
      maxStringCount: 40,
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    DateOfBirth: {
      name: 'DateOfBirth',
      label: 'Date of birth*',
      minAgeErrorMsg: 'Person can\'t be older than 100 years.',
      maxAgeErrorMsg: 'Person should be at least 16 year old.',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    Gender: {
      name: 'Gender',
      label: 'Gender*',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    CountryOfNationality: {
      name: 'CountryOfNationality',
      label: 'Country of nationality*',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    PreferredEmail1: {
      name: 'PreferredEmail1',
      label: 'Preferred email 1*',
      maxStringCount: 100,
      informationText: <>This email address will be used for all portal related communications. This is a mandatory field. <br /><br />Please note: if you change your preferred email address, you may start to receive communications you had previously opted out of. If this happens, simply unsubscribe as required.</>,
      get typeError(): string {
        return validationMessages.invalid(this.label);
      },
      get requiredErrorMesssag(): string {
        return validationMessages.required(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    AlternateEmail2: {
      name: 'AlternateEmail2',
      label: 'Alternate email 2',
      maxStringCount: 100,
      get typeError(): string {
        return validationMessages.invalid(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    AlternateEmail3: {
      name: 'AlternateEmail3',
      label: 'Alternate email 3',
      maxStringCount: 100,
      get typeError(): string {
        return validationMessages.invalid(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    PreferredPhoneNumber: {
      name: 'PreferredPhoneNumber',
      label: 'Preferred phone number*',
      maxStringCount: 55,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get typeError(): string {
        return validationMessages.invalid(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    AlternatePhoneNumber: {
      name: 'AlternatePhoneNumber',
      label: 'Alternate phone number',
      maxStringCount: 50,
      get typeError(): string {
        return validationMessages.invalid(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    LinkedInUrl: {
      name: 'LinkedInUrl',
      label: 'LinkedIn URL',
      maxStringCount: 150,
      formatErrorMessage: 'Invalid URL format',
      expression: /^(http(s):\/\/.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/,
      get requiredErrorMesssag(): string {
        return validationMessages.required(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    Discipline: {
      name: 'Discipline',
      label: 'Discipline*',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    AreaOfPracticeMoreDetails: {
      name: 'AreaOfPracticeMoreDetails',
      label: 'Area of practice*',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    PostalAddressLines: {
      name: 'PostalAddressLines',
      label: 'Address*',
      maxStringCount: 1000,
      information_text: 'Please exclude country from \'address\' field and select it using the \'address country\' dropdown below.',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    PostalAddressCountry: {
      name: 'PostalAddressCountry',
      label: 'Country*',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    LocationCountry: {
      name: 'LocationCountry',
      label: 'Country of practice*',
      information_text: 'Location determines membership rate.',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    CountrySubdivision: {
      name: 'CountrySubdivision',
      label: 'County/state/province*',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    CountryOfPractice: {
      name: 'CountryOfPractice',
      label: 'Country of practice'
    },
    IMCNumber: {
      name: 'IMCNumber',
      label: 'IMC number'
    },
    RegType: {
      name: 'RegType',
      label: 'Reg type'
    },
    Scheme: {
      name: 'Scheme',
      label: 'Scheme'
    },
    EngagedInMedicine: {
      name: 'EngagedInMedicine',
      label: 'Engaged in medicine'
    },
    RegistrationSpecialty: {
      name: 'RegistrationSpecialty',
      label: 'Registration specialty '
    },
    Subspecialty: {
      name: 'Subspecialty',
      label: 'Subspecialty'
    },
    EducationDetails: {
      name: 'EducationDetails',
      label: 'Education details'
    },
    WorkDetails: {
      name: 'WorkDetails',
      label: 'Work details'
    },
    WorkDetails1: {
      name: 'WorkDetails',
      label: 'Work details'
    },
    AlumniMagazinePreference: {
      name: 'AlumniMagazinePreference',
      label: 'Alumni magazine preference*',
      get requiredErrorMesssag(): string {
        return validationMessages.required(this.label);
      }
    },
    SurgeonsScopeMagazine: {
      name: 'SurgeonsScopeMagazine',
      label: 'Surgeons Scope magazine*',
      get requiredErrorMesssag(): string {
        return validationMessages.required(this.label);
      }
    },
    TheSurgeonJournal: {
      name: 'TheSurgeonJournal',
      label: 'The Surgeon journal*',
      get requiredErrorMesssag(): string {
        return validationMessages.required(this.label);
      }
    },
    OptIntoDirectMarketing: {
      name: 'OptIntoDirectMarketing',
      label: `Select 'Yes' to stay up-to-date with news, events and to receive 
        personalised communications and promotions from RCSI.`,
      information_text: `Curious how we use your data? Email alumni@rcsi.com to 
        receive our data protection statement.`
    },
    CurrentUserRoles: {
      name: 'CurrentUserRoles'
    },
    ShareMyEmailWithMyClassmates: {
      name: 'ShareMyEmailWithMyClassmates',
      label: 'Share my email with my classmates'
    },
    Declaration: {
      name: 'Declaration',
      label: `Declaration:

      I do solemnly and sincerely declare and promise that I will observe and be obedient to the Statutes,
      Bye-Laws and Ordinances of the Royal College of Surgeons
      in Ireland, and that I will to the utmost of my power,
      endeavour to promote the reputation, honour and dignity of
      the said College. I promise to place the welfare of my patients above all else. I promise to be respectful of my fellow healthcare
      professionals and will readily offer them my assistance and
      support. I further promise to continue to learn and teach and
      maintain my competence, for the benefit of my patients,
      trainees and the society in which I serve.” 
      
      By ticking this box, you confirm that you agree to abide by the College's Statutes, Bye-Laws, and Ordinances of Fellowship.*`,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    MembershipDeclaration: {
      name: 'MembershipDeclaration',
      label: <>
        If you have been successfully accepted as an exam candidate for the MRCS Part A or Part B exams do not
        complete this application as you will automatically receive Affiliate Membership through that programme.

        <br></br>
        <br></br>

        If you have already sat the MRCS Part B exam and you have passed or you are awaiting results,
        you are not currently eligible for RCSI Affiliate Membership.
        Please email <a href="mailto:fellows@rcsi.com">fellows@rcsi.com</a> for more information.


        <br></br>
        <br></br>
        <b>
          By ticking this box, you confirm that you have <u>not</u> sat the MRCS Part B exam with RCSI
          or one of the Royal Colleges (RCSEd, RCSEng, or RCPSG) and passed, or are awaiting results.
        </b>
      </>,
      requiredErrorMsg: 'Declaration is required.'
    },
    MembershipType: {
      name: 'MembershipType',
      label: 'Membership type'
    },
    MembershipCountry: {
      name: 'MembershipCountry',
      label: 'Country of practice'
    },
    MembershipFeeDue: {
      name: 'MembershipFeeDue',
      label: 'Fee due'
    },
    EducationalDetailsCountry: {
      name: 'EducationalDetailsCountry',
      label: 'Country of medical school*',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    UniversityOrCollegePrimaryMedicalDegree: {
      name: 'UniversityOrCollegePrimaryMedicalDegree',
      label: 'Medical school*',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    QualificationYear: {
      name: 'QualificationYear',
      label: 'Qualification year'
    },
    Award: {
      name: 'Award',
      label: 'Award*',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    IsCourseCompleted: {
      name: 'IsCourseCompleted',
      label: 'Have you completed the course?*',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    YearOfConferring: {
      name: 'YearOfConferring',
      label: 'Year of conferring*',
      get typeError(): string {
        return validationMessages.invalid(this.label);
      },
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get minErrorMsg(): string {
        return `${this.label.replace('*', '')} should be in between ##MIN_YEAR## and ##MAX_YEAR##.`;
      },
      get maxErrorMsg(): string {
        return `${this.label.replace('*', '')} shouldn\'t be future year.`;
      }
    },
    LevelOfStudyOrTraining: {
      name: 'LevelOfStudyOrTraining',
      label: 'Level of study/training*',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    StatusAffiliateMemberPathway: {
      name: 'StatusAffiliateMemberPathway',
      label: 'Affiliate member pathway*',
      information_text: <>
        If one of the following applies to you, you are eligible to apply for one subscription year free:
        <ul>
          <li>Enrolled on Master of Surgery</li>
          <li>Active Member of RCSI Surgical Society - Dublin and Bahrain</li>
          <li>Doctors from regions impacted by war</li>
        </ul>
        All other applicants should select 'General Applicant'
      </>,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    AffiliateMemberPathwayComments: {
      name: 'AffiliateMemberPathwayComments',
      maxStringCount: 2000
    },
    HaveNotSuccessfullyPassedMrcsPartBExam: {
      name: 'HaveNotSuccessfullyPassedMrcsPartBExam',
      requiredErrorMsg: 'Your choice is required here'
    },
    ReasonToBecomeAffiliateMemberOfRCSI: {
      name: 'ReasonToBecomeAffiliateMemberOfRCSI',
      label: 'Briefly outline why you wish to become an Affiliate Member of RCSI*',
      maxStringCount: 2000,
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      },
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    NameOnCertificate: {
      name: 'NameOnCertificate',
      label: 'Name on certificate*',
      maxStringCount: 100,
      information_text: `Please confirm your full name as it should appear on your certificate. We advise that the name on your 
        certificate matches the name on your passport for the purpose of verification. You may be required to submit a copy 
        of your passport to verify the name you wish to appear on your certificate if it differs to the name on your exam results. 
        Any certificate reprints required due to an error or typo in the name provided may incur a charge.`,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    PetitionForElection: {
      name: 'PetitionForElection',
      label: 'Petition for Election: To be deemed eligible for election to the College at an RCSI Council meeting, please tick the Petition for Election box*',
      information_text: 'Pending Approval: I request that my name be placed before the Council of the Royal College of Surgeons in Ireland (RCSI) for election ' +
        'as a Fellow or Member of the College, having passed the necessary examinations.',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    Certificate: {
      name: 'Certificate',
      label: 'Copy of membership certificate issued by other Royal College*',
      invalidFileTypeErrorMsg: validationMessages.invalidFileType('.png or .pdf'),
      invalidFileSizeErrorMsg: validationMessages.invalidFileSize(5),
      fileNotUploaded: `Certificate not uploaded.`,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    Exam: {
      name: 'Exam',
      label: 'Written verification of having previously passed the Intercollegiate Membership exam (MRCS Part B OSCE)*',
      invalidFileTypeErrorMsg: validationMessages.invalidFileType('.png or .pdf'),
      invalidFileSizeErrorMsg: validationMessages.invalidFileSize(5),
      fileNotUploaded: `Exam document not uploaded.`,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    CV: {
      name: 'CV',
      label: 'A current curriculum vitae*',
      invalidFileTypeErrorMsg: validationMessages.invalidFileType('.png or .pdf'),
      invalidFileSizeErrorMsg: validationMessages.invalidFileSize(5),
      fileNotUploaded: `CV not uploaded.`,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    WhichRoyalCollegeAreYouTransferringFrom: {
      name: 'WhichRoyalCollegeAreYouTransferringFrom',
      label: 'Which Royal College are you transferring from?*',
      information_text: 'Membership of RCSI can be achieved by transfer from one of the following Royal Colleges: RCSEd, RCSEng and RCPSG.',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    VolunteeringComment: {
      name: 'VolunteeringComment',
      label: 'Volunteering comment',
      maxStringCount: 100,
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    }
  }
};

export default MembershipFormModel;
